import * as yup from 'yup';

import { vermietungsObjektSchema } from '@/features/Sparten/res/schema/vermietungObjektSchema/vermietungsObjektSchema';

export const leistungsumfangSchema = yup
  .object({
    privat: yup.boolean().default(true),
    beruf: yup.boolean().default(false),
    verkehr: yup.boolean().default(false),
    hasMehrereFahrzeuge: yup.boolean().default(false),
    anzahlFahrzeuge: yup.number().min(2).max(6).default(2),
    mieten: yup.boolean().default(false),
    vermietung: yup.boolean().default(false),
    vermietungObjekteAnzahl: yup.array().default([0]).of(yup.number()),
    bruttojahresmieteBetrag0: vermietungsObjektSchema.when('vermietung', {
      is: (val: boolean) => val,
      then: yup.number().required(),
    }),
    bruttojahresmieteBetrag1: vermietungsObjektSchema,
    bruttojahresmieteBetrag2: vermietungsObjektSchema,
  })
  .test({
    name: 'isRequired',
    message: 'Mindestens ein Leistungsumfang muss ausgewählt sein.',
    test(value) {
      return value.privat || value.verkehr || value.mieten || value.vermietung;
    },
  });
